import { text_colorTextPrimary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium } from 'ext-ui/style/typography'
import { css } from 'styled-components'

/**
 * Payments page (Bill Pay M3). Deliberately mirrors VendorsPage.style so the
 * two Bill Pay surfaces read as one section: header row with the title, then a
 * bordered Box that fills the remaining page height and holds history.
 */
export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(5)};
  flex: 1;
  min-height: 0;

  .payments-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }

  .payments-title {
    font-size: 32px;
    line-height: 36px;
    font-family: ${font_family_weight_medium};
    color: ${text_colorTextPrimary};
    margin: 0;
  }

  /* Same flex-1 container chain as the Vendors card: the bordered Box fills
     the remaining page height rather than shrink-wrapping its contents. Box is
     a plain div with no built-in stretch, so the page establishes it here. */
  .payments-box {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    width: 100%;
  }
`
